import { render, staticRenderFns } from "./TransferRouter.vue?vue&type=template&id=1cd14662&scoped=true"
import script from "./TransferRouter.vue?vue&type=script&lang=js"
export * from "./TransferRouter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cd14662",
  null
  
)

export default component.exports